import React from "react";
import { Navigate } from "react-router-dom";
import ApproveZapierIntegrationModal from "../../Model/ApproveZapierIntegrationModal";

const ExternalAuthorize = () => {
  const userData = JSON.parse(localStorage.getItem("userData"));

  if (!userData) {
    return (
      <Navigate
        state={{
          redirectUrl: window.location.pathname + window.location.search,
        }}
        to="/"
        replace={true}
      />
    );
  }

  return <ApproveZapierIntegrationModal />;
};

export default ExternalAuthorize;
